import { type ReactElement } from 'react';

export const Globe = (props: React.SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM4.24592 10.0239C4.08534 10.656 4 11.318 4 12C4 12.6906 4.08751 13.3608 4.25204 14H19.748C19.9125 13.3608 20 12.6906 20 12C20 11.318 19.9147 10.656 19.7541 10.0239H4.24592ZM4.57188 9.02393H19.4281C18.2473 6.07943 15.3665 4 12 4C8.6335 4 5.75267 6.07943 4.57188 9.02393ZM12 20C8.64262 20 5.76829 17.9318 4.58152 15H19.4185C18.2317 17.9318 15.3574 20 12 20Z"
        fill="#0D0D0D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.93763 5.81304C9.53462 4.23126 10.5205 3 12 3C13.4755 3 14.4803 4.22573 15.0958 5.80838C15.7244 7.42516 16.0393 9.61793 16.0393 12C16.0393 14.3821 15.7244 16.5748 15.0958 18.1916C14.4803 19.7743 13.4755 21 12 21C10.5205 21 9.53462 19.7687 8.93763 18.187C8.32768 16.5708 8.03103 14.3792 8.03103 12C8.03103 9.62076 8.32768 7.42915 8.93763 5.81304ZM9.87321 6.16615C9.32207 7.62643 9.03103 9.68482 9.03103 12C9.03103 14.3152 9.32207 16.3736 9.87321 17.8339C10.4373 19.3285 11.1859 20 12 20C12.8181 20 13.5829 19.3229 14.1637 17.8292C14.7313 16.3696 15.0393 14.3123 15.0393 12C15.0393 9.68765 14.7313 7.63042 14.1637 6.1708C13.5829 4.67706 12.8181 4 12 4C11.1859 4 10.4373 4.67153 9.87321 6.16615Z"
        fill="#0D0D0D"
      />
    </svg>
  );
};
